import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translator } from 'mage-i18n';
import { IconSettings, SpacerVertical } from '@klarna/bubble-ui';
import { defaultContainerPropTypes, Selector, propUtils } from 'moet-core';
import ContainerTemplatePsp from '@/components/ContainerTemplatePsp';
import { T_PREFIX } from '@/containers/PaymentServiceProviders/constants';
import { logEvent } from '@/utils/analytics';
/* eslint-disable no-restricted-imports */
// @ts-expect-error: FIXME
import klarnaLogo from '../../../static/logo-klarna.svg';
// @ts-expect-error: FIXME
import stripeLogo from '../../../static/logo-stripe.svg';
// @ts-expect-error: FIXME
import adyenLogo from '../../../static/logo-adyen.svg';
// @ts-expect-error: FIXME
import mollieLogo from '../../../static/logo-mollie.svg';
/* eslint-enable no-restricted-imports */
import { getAllPartners } from '@/selectors/partners';
import { ANALYTICS_EVENTS } from './analyticsEvents';
const logoProps = { backgroundColorToken: 'colors/util/transparent', hasBorder: false };
const PLATFORM_LOGO_URL_MAP = {
    klarna: klarnaLogo,
    mollie: mollieLogo,
    stripe: stripeLogo,
    adyen: adyenLogo,
};
export const PaymentServiceProviders = ({ partners, t, }) => {
    const [loading] = useState(false);
    const { country } = propUtils.getQueryParamsFromProps(window);
    const options = [
        ...partners
            .filter(partner => partner.supportedCountries.includes(country))
            .sort((a, b) => a.onboarding.sortOrder - b.onboarding.sortOrder)
            .map(({ id, name, onboarding, supportedCountries }) => ({
            value: {
                id,
                name,
                onboarding,
                supportedCountries,
            },
            label: id === 'custom' ? t(`${T_PREFIX}.custom`) : name,
            logoUri: id === 'custom' ? undefined : PLATFORM_LOGO_URL_MAP[id],
            icon: id === 'custom' ? IconSettings : undefined,
            url: onboarding.url,
            logoProps,
        })),
    ];
    const onSelect = useCallback((partner) => {
        const redirectUrl = partner.onboarding.url;
        if (redirectUrl) {
            logEvent(ANALYTICS_EVENTS.submitPSPPartner, {
                psp: partner.name,
            });
            window.open(redirectUrl, '_blank');
        }
    }, [loading]);
    return (React.createElement(ContainerTemplatePsp, { title: t(`${T_PREFIX}.title_line_1`), subtitle: t(`${T_PREFIX}.subtitle`) },
        React.createElement(Selector, { id: "platform--selector", loading: loading, options: options, onSelect: onSelect }),
        React.createElement(SpacerVertical, { large: true })));
};
PaymentServiceProviders.propTypes = Object.assign(Object.assign({}, defaultContainerPropTypes), { partners: PropTypes.array.isRequired, t: PropTypes.func.isRequired });
export default connect(state => ({
    partners: getAllPartners(state),
    t: translator(state),
}))(PaymentServiceProviders);
